import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { forHumans, riskForHumans } from "@madmedical/medical";
import { useMemo } from "react";
import { formatDateRange } from "@madmedical/utils";
import { Divider, HStack, Pressable, Text, VStack } from "native-base";
import { useTranslation } from "@madmedical/i18n";
import { useRouteNavigate } from "../providers/routing";
import { usePredictions } from "../providers/prediction";
import ReactTable from "../molecules/ReactTable";
import Tag from "../atoms/Tag";
import useResponsive from "../util/useResponsive";
const PredictionsTable = ({ onEndReached }) => {
    const { predictions } = usePredictions();
    const navigate = useRouteNavigate();
    const { isSmallScreen } = useResponsive();
    const { t } = useTranslation();
    const columns = useMemo(() => [
        {
            Header: t("measures:title"),
            width: "auto",
            Cell: ({ row }) => (_jsx(_Fragment, { children: row.original.trends.map(({ metricType }) => (_jsx(Tag, Object.assign({ mr: 1 }, { children: t(`measures:${forHumans(metricType)}`) }), metricType))) })),
        },
        {
            Header: t("measures:measuredPeriod"),
            accessor: "dateRange",
            width: "30%",
            Cell: ({ value: dateRange }) => (_jsx(_Fragment, { children: formatDateRange(dateRange, "long") })),
        },
        {
            Header: t("measures:alert"),
            width: "30%",
            accessor: "risks",
            Cell: ({ value: risks }) => (_jsx(_Fragment, { children: risks.map((risk) => riskForHumans(risk)).join(", ") })),
        },
    ], [t]);
    const handleRowPress = ({ id }) => {
        navigate("prediction", { predictionId: id });
    };
    return isSmallScreen ? (_jsx(VStack, Object.assign({ divider: _jsx(Divider, {}) }, { children: predictions.map((prediction) => (_jsx(Pressable, Object.assign({ onPress: () => handleRowPress(prediction) }, { children: _jsxs(VStack, Object.assign({ backgroundColor: "white", px: "4", py: "5", space: "1" }, { children: [_jsx(HStack, Object.assign({ space: "1", flexWrap: "wrap" }, { children: prediction.trends.map(({ metricType }) => (_jsx(Tag, Object.assign({ variant: "ghost" }, { children: t(`measures:${forHumans(metricType)}`) }), metricType))) })), _jsxs(HStack, Object.assign({ space: "1", flexWrap: "wrap" }, { children: [_jsx(Text, Object.assign({ fontSize: "xs", color: "gray.600" }, { children: formatDateRange(prediction.dateRange, "short") })), _jsx(Divider, { orientation: "vertical" }), _jsx(Text, Object.assign({ fontSize: "xs", color: "gray.600" }, { children: prediction.risks
                                    .map((risk) => riskForHumans(risk))
                                    .join(", ") }))] }))] })) }), prediction.id))) }))) : (_jsx(ReactTable, { columns: columns, data: predictions, onEndReached: onEndReached, onPress: handleRowPress }));
};
export default PredictionsTable;
